<div class="bg-red-500 text-white flex justify-between items-center p-2">
  <div class="w-[200px] flex justify-items-start">
    <hd-version [whiteText]="true"/>
  </div>
  <div class="flex items-center gap-2">
    <div class="text-3xl">DEMO</div>
    <div>logged as
      @if (userRoleSignal$$(); as userRole) {
        @if (userRole === RoleTypes.CONSUMER) {
          <span class="bg-requestor p-2 text-neutral-10-primary">{{ userRole }}</span>
        }

        @if (userRole === RoleTypes.PROVIDER) {
          <span class="bg-provider p-2 text-neutral-10-primary">{{ userRole }}</span>
        }
        @if (userRole === RoleTypes.HD) {
          <span class="bg-primary-fill p-2 text-white">{{ userRole }}</span>
        }
      }
    </div>

  </div>
  <div class="w-[200px] text-right">{{userEmail}}</div>
</div>
